import { Injectable } from '@angular/core';

const STORAGE_KEY = 'tenant_history';

@Injectable({ providedIn: 'root' })
export class TenantHistoryService {

  recordVisit(tenantCode: string): void {
    const history = this.getHistory().filter(code => code !== tenantCode);
    localStorage.setItem(STORAGE_KEY, JSON.stringify([tenantCode, ...history]));
  }

  getHistory(): string[] {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]');
    } catch {
      return [];
    }
  }

  getLastUsed(): string | null {
    return this.getHistory()[0] ?? null;
  }

  removeFromHistory(tenantCode: string): void {
    const history = this.getHistory().filter(code => code !== tenantCode);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
  }
}
